
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.746 1.286l-7.26 3.717L.6 3.583 7.732.061a.585.585 0 01.52 0l2.494 1.225zM15.392 3.583l-7.388 3.66L5.237 5.88l-.4-.203 7.269-3.717.4.203 2.886 1.42zM7.412 8.298L7.404 16 .328 12.307A.618.618 0 010 11.763V4.638l2.999 1.477v2.597c0 .333.272.609.6.609.328 0 .6-.276.6-.609V6.716l.4.194 2.813 1.388zM15.992 4.646L8.611 8.29l-.008 7.703L16 12.13l-.008-7.484z","fill":"#6C6C6C"}})])
          )
        }
      }
    